<template>
  <div>
    <div class="details">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基本信息" name="first">
          <el-form class="record-box">
            <el-form-item label="区域名称：">{{ pageData.customer_area_name }}</el-form-item>
            <el-form-item label="服务人员：">{{ pageData.nurse_name }}</el-form-item>
            <div style="display: flex;">
              <img v-if="pageData.customer_photo_path" :src="pageData.customer_photo_path" alt=""
                style="background-color: #f2f2f2;width: 130px;height: 130px;margin-top: 7px;margin-right: 20px;">
              <div style="flex: 1;">
                <el-form-item label="服务对象姓名：" style="margin-bottom: 0;">{{ pageData.customer_name }}
                </el-form-item>
                <el-form-item label="性别：" style="margin-bottom: 0;">{{ pageData.customer_sex | isSex}}
                </el-form-item>
                <el-form-item label="年龄：" style="margin-bottom: 0;">{{ pageData.customer_age }}
                </el-form-item>
                <el-form-item label="手机号：" style="margin-bottom: 0;">{{ pageData.customer_phone }}
                </el-form-item>
              </div>
            </div>
            <el-form-item label="身份证号码：">{{ pageData.customer_identity_card_number }}</el-form-item>
            <el-form-item label="贫困编号：">{{ pageData.customer_poverty_number }}</el-form-item>
            <el-form-item label="户籍所在地：">{{ pageData.customer_registration_address }}</el-form-item>
            <el-form-item label="现居住地：">{{ pageData.customer_current_address }}</el-form-item>


            <el-form-item label="监护人1：">
              {{ pageData.customer_guardian_info?pageData.customer_guardian_info[0].name:'' }}
              电话{{ pageData.customer_guardian_info?pageData.customer_guardian_info[0].phone:'' }}
            </el-form-item>
            <el-form-item label="监护人2：">
              {{ pageData.customer_guardian_info?pageData.customer_guardian_info[1].name:'' }}
              电话{{ pageData.customer_guardian_info?pageData.customer_guardian_info[1].phone:'' }}
            </el-form-item>
            <!-- <el-form-item label="服务状态：">
					<span v-if="pageData.service_status == 1">服务中</span>
					<span v-if="pageData.service_status == 2">已结束</span>
				</el-form-item> -->
            <el-form-item label="居住状况："> {{ pageData.customer_dwell_status }}</el-form-item>
            <el-form-item label="健康状况："> {{ pageData.customer_health_status }}</el-form-item>
            <el-form-item label="重要程度："><span
                :class="'state-'+pageData.customer_important_degree">{{ pageData.customer_important_degree | isImportant }}</span>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="服务记录" name="record">
          <div v-loading='loading_log' class="record-box">
            <!-- <el-select v-model="recodeQuery.add_date" placeholder="请选择" @change='handleChange'>
              <el-option v-for="item in DateList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select> -->

            <el-date-picker class="my-date" style="width: 120px;" v-model="recodeQuery.add_date" type="month" value-format="yyyy-MM"
              :clearable='false' :defaultValue='defaultValue' placeholder="请选择" @change='handleChange'>
            </el-date-picker>

            <span style="color: #333;font-size: 14px;padding-left: 20px;">
              线上（<span style="color: #2F91FE;">{{ query_log.total }}</span>）
              线下（<span style="color: #2F91FE;">{{ current_month_service_total_offline }}</span>）
            </span>
            <div style="margin-top: 15px;" v-if="recordList.length || list_log.length">
              <el-button v-if="JudgeButton(role_permission,'customerLog/preCheckPass')" @click="type=4;check()" type="success" style="width: 112px;background-color: #42B983;"> 预审合格
              </el-button>
              <el-button v-if="JudgeButton(role_permission,'customerLog/checkPass')" @click="type=1;check()" type="success" style="width: 112px;margin-left:20px;"> 合格
              </el-button>
              <el-button v-if="JudgeButton(role_permission,'customerLog/checkUnPass')" @click="dialogVisible1=true;type=2;" type="warning" style="width: 112px;margin-left:20px;">不合格
              </el-button>
              <el-button @click="dialogVisible1=true;type=3;" type="danger" v-if="JudgeButton(role_permission,'customerLog/endCheckUnPass') && userInfo.role_id == 1"
                style="margin-left:20px;">终审不合格</el-button>
            </div>
            <el-divider content-position="left" style="font-weight: bold">线上服务</el-divider>
            <div>
              <el-form ref="elForm" inline>
                <el-form-item style="margin-right: 20px;">
                  <el-input v-model="query_log.abstract" placeholder="请输入记录摘要" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item style="margin-right: 20px;">
                  <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange(1)">查询
                  </el-button>
                </el-form-item>
                <el-form-item style="margin-right: 20px;" v-if="JudgeButton(role_permission,'customerLog/onlineLogDelete')">
                  <el-button type="danger" :disabled="!multipleSelection.length" @click="delAll"
                    icon="el-icon-milk-tea"> 删除 </el-button>
                </el-form-item>
                <!-- <el-form-item>
					  	   <el-button :disabled="!list_log.length" type="warning" icon="el-icon-upload" @click="handleExport">导出</el-button>
					  	 </el-form-item> -->
              </el-form>
              <el-table stripe border ref="multipleTable" :data="list_log" tooltip-effect="dark"
                @selection-change="handleSelectionChange">
                <el-table-column align='center' type="selection" width="55"></el-table-column>
                <el-table-column align='center' prop='user_name' label="社工姓名" width="120">
                </el-table-column>
                <el-table-column align='center' prop="add_time" label="创建时间" width="180">
                </el-table-column>
                <el-table-column align='center' prop="abstract" label="摘要" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align='center' label="文件">
                  <template slot-scope="scope">
                    <div class="file-list" v-if="scope.row.file">
                      <img @click="videoUrl='';imgUrl=item;dialogVisible_log=true;" v-for="(item,i) in scope.row.file"
                        :key="i" :src="item + '?imageMogr2/thumbnail/100x'" alt="">
                    </div>
                    <span v-else style="opacity: 0.5;">无</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align='center' width='100'>
                  <template slot-scope="scope" v-if="JudgeButton(role_permission,'customerLog/onlineLogDelete')">
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination style="margin: 30px auto;text-align: center;" v-if="query_log.total > query_log.page_limit"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query_log.page"
                :page-size="query_log.page_limit" layout="total, prev, pager, next, jumper" :total="query_log.total">
              </el-pagination>
            </div>
            <el-divider content-position="left" style="font-weight: bold">线下服务</el-divider>
            <el-row v-for="(item,i) in recordList" :key='i' class="off-box">
              <el-col :span='19'>
                <el-form inline class="cc">
                  <el-form-item label="服务对象名称：">{{ item.customer_name }}</el-form-item>
                  <el-form-item label="服务人员：">{{ item.nurse_user_name }}</el-form-item>
                  <el-form-item label="签到时间：">{{ item.sign_time }}</el-form-item>
                  <el-form-item label="开始服务时间：">{{ item.service_start_date }}</el-form-item>
                  <el-form-item label="签到地址：">{{ item.sign_address }}</el-form-item>
                  <el-form-item label="结束服务时间：" v-if='item.service_status == 2'>{{ item.service_end_date }}</el-form-item>
                  <el-form-item label="签退地址：" v-if='item.service_status == 2'>{{ item.sign_out_address }}</el-form-item>
                  <el-form-item label="签退时间：" v-if='item.service_status == 2'>{{ item.sign_out_time }}</el-form-item>
                  <!-- <el-form-item label="最低服务时长："><span style="color: red;"
											v-if="item.service_project_duration">{{ item.service_project_duration | time }}</span>
									</el-form-item> -->
                  <el-form-item label="服务时长：" v-if='item.service_status == 2'>{{ item.service_duration }}</el-form-item>
                  <el-form-item label="服务项目：">{{ item.service_project_name | project_name }}</el-form-item>
                  <el-form-item label="服务状态：">
                    <span v-if="item.service_status == 1">服务中</span>
                    <span v-if="item.service_status == 2">已结束</span>
                  </el-form-item>
                  <el-form-item label="服务评价：" style="width: 100%;">
                    <el-rate v-if="item" style="position: relative;top: 9px;" disabled
                      v-model="item.service_comment_level"></el-rate>
                    <div v-if="item.service_comment_status == 1" style="margin-top: 20px;">
                      <div>
                        {{ item.service_comment_content }}
                      </div>
                      <div v-if="item.comment_files && item.comment_files.length">
                        <div style="display: inline-block;margin-right: 20px;margin-bottom: 20px;"
                          v-for="(item,i) in item.comment_files" :key="i">
                          <el-image v-if="item.type == 'image'"
                            style="width: 130px; height: 130px; box-shadow: 0 0 6px 1px rgba(0,0,0,0.1);border-radius: 4px;"
                            :src="item.url" @click="videoUrl='';imgUrl = item.url;dialogVisible_log=true;" fit="cover">
                          </el-image>
                          <div v-if="item.type == 'video'"
                            @click="imgUrl='';videoUrl = item.url;dialogVisible_log=true;"
                            style="width: 130px; height: 130px; box-shadow: 0 0 6px 1px rgba(0,0,0,0.1);border-radius: 4px;position: relative;">
                            <video :src="item.url" style="width: 100%;height: 100%;"></video>
                            <div class="videomask">
                              <i class="el-icon-video-play"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <el-button type="primary" icon='el-icon-edit' size='mini' @click="replay(item)" v-if="JudgeButton(role_permission,'customerLog/replayComment')">
                        回复评价</el-button>
                    </div>
                  </el-form-item>
                  <!-- <el-form-item label="区域名称：">{{ item.sign_area_name }}</el-form-item>
								<el-form-item label="居住地址：">{{ item.customer_current_address }}</el-form-item> -->
                </el-form>
              </el-col>
              <el-col :span='5' v-if="JudgeButton(role_permission,'customerLog/offlineLogDelete')">
                <el-button style="margin-left: 20px;" type="danger" @click="handleDeleteOffLine(item)">
                  删除</el-button>
                <el-button v-if="JudgeButton(role_permission,'customerLog/offlineLogComment')" style="margin-left: 20px;" type="primary" @click="$refs.star.show(item)">评分
                </el-button>
              </el-col>
            </el-row>
            <div class="_empty-text" v-if="!recodeLoading && !recordList.length">暂无数据</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="跟进记录" name="second">
          <div class="record-box">
            <div>
              <el-date-picker v-model="value2" type="daterange" @change="change" value-format='yyyy-MM-dd'
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
              <el-button style="margin-left: 20px;" type="primary"
                @click="loading=true;query.page=1;getCustomerFollowUpLogList()">查询</el-button>
            </div>
            <div style="margin-top: 20px;">
              <el-table v-loading='loading' stripe border :data="list">
                <el-table-column align='center' prop="create_time" label="日期" width="180">
                </el-table-column>
                <el-table-column align='center' prop="founders" label="服务人员" width="180">
                </el-table-column>
                <el-table-column align='center' prop="log_content" show-overflow-tooltip label="跟进内容">
                </el-table-column>
                <el-table-column label="操作" align='center' width='180'>
                  <template slot-scope="scope" v-if="JudgeButton(role_permission,'customerLog/details')">
                    <el-button type="primary" icon='el-icon-edit' size='mini' @click="$refs.replyList.show(scope.row)">
                      跟进回复</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
                @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="query.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit"
                layout="total, sizes, prev, pager, next, jumper" :total="query.total">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible_log" width="60%">
      <video v-if="videoUrl" :src="videoUrl" style='width: 100%;display: block;max-height: 80vh;' controls></video>
      <img v-if="imgUrl" :src="imgUrl" style='width: 100%;display: block;' />
    </el-dialog>
    <el-dialog title="审核不合格" :visible.sync="dialogVisible1" width="30%">
      <el-form>
        <el-form-item label="不合格原因：" required>
          <el-input type='textarea' rows='7' :maxlength='500' show-word-limit v-model="service_audit_remark"
            placeholder="请输入原因" clearable style="width: 100%;">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1=false">取消</el-button>
        <el-button type="primary" @click="check()">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="评价回复" :visible.sync="dialogVisible" width="30%">

      <el-form ref="added" size="medium">
        <el-form-item label="评价回复内容：" required>
          <el-input type='textarea' rows='7' :maxlength='500' show-word-limit v-model="reply_content"
            placeholder="请输入回复内容" clearable style="width: 100%;">
          </el-input>
        </el-form-item>
        <el-button type="primary" @click="handelConfirm">提交回复</el-button>
      </el-form>
      <div v-if="commentList.length" style="margin-top: 30px;">
        <div class="item" v-for="(item,i) in commentList" :key="i">
          <div class="flexbox">
            <div>{{ item.reply_role_name }}: {{ item.reply_content }}</div>
            <i v-if="userInfo.uid == item.uid" class="el-icon-delete-solid" @click="del(item)"></i>
          </div>
          <div style="opacity: 0.6;">{{ item.reply_time }}</div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
    <star ref='star' @success='getOnlineList'></star>
    <replyList ref="replyList"></replyList>
  </div>
</template>

<script>
  import userInfoAPI from '@/api/api';
  import star from './components/star.vue';
  import replyList from './components/replyList.vue';
  export default {
    name: 'servicedetails',
    components: {
      star,
      replyList
    },
    props: {},
    data() {
      return {
        loading: true,

        id: '',
        states: [
          // {label:'全部', value: ''},
          {
            label: '未审核',
            value: 0
          },
          {
            label: '合格',
            value: 1
          },
          {
            label: '不合格',
            value: 2
          },
          {
            label: '终审不合格',
            value: 3
          },
        ],
        activeName: 'record',
        pageData: '',
        value2: '',
        list: [],
        videoUrl: '',
        query: {
          page_limit: 10,
          page: 1,
          customer_id: '',
          start_date: '',
          end_date: '',
          total: 0
        },
        formData1: {
          user_name: ''
        },
        DateList: [],

        // 线下
        dialogVisible1: false,
        recodeQuery: {
          customer_name_or_phone: '',
          founders_name_or_phone: '',
          service_status: '',
          service_audit_status: '',
          comment_level: '',
          page_limit: 999,
          page: 1,
          flag: '', // 操作标志 export=数据导出
          add_date: '',
          customer_id: '',
          service_comment_status: 1
        },
        recordList: [],
        recodeLoading: true,

        commentList: [],
        dialogVisible: false,
        reply_content: '',

        // 线上
        type: 1,
        multipleSelection: [],
        list_log: [],
        query_log: {
          cid: '',
          abstract: '',
          page_limit: 10,
          page: 1,
          flag: '', // 操作标志 export=数据导出
          total: 0,
          add_date: ''
        },
        dialogVisible_log: false,
        imgUrl: '',
        loading_log: true,
        userInfo: '',
        service_audit_remark: '',
        current_month_service_total_offline: 0,
        defaultValue: ''
      }
  },
        computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    created() {
      this.id = this.$route.query.customer_id;
      if (this.id) {
        this.query.customer_id = this.id
        this.recodeQuery.customer_id = this.id
        this.query_log.cid = this.id
        if (this.$route.query.date) {
          this.recodeQuery.add_date = this.$route.query.date
          this.query_log.add_date = this.$route.query.date
          this.defaultValue = this.$route.query.date
        }
        userInfoAPI.getUserInfo().then(res => {
          this.userInfo = res.data.data
          this.getDateList()
        })
      }
    },
  methods: {
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      handleChange(e) {
        console.log(e)
        this.recodeQuery.add_date = e
        this.query_log.add_date = e
        this.handleCurrentChange(1)
      },
      getDateList() {
        userInfoAPI.getDateList().then((res) => {
          if (res.data.code == 0) {
            this.DateList = res.data.data || []
            if (!this.recodeQuery.add_date) {
              this.recodeQuery.add_date = this.DateList[0]
              this.query_log.add_date = this.DateList[0]
            }
          }
          this.getOnlineList()
          this.getDetail()
        })
      },

      // 线上开始
      handleExport() {
        this.query_log.flag = 'export';
        this.getOnlineList();
      },
      handleSizeChange(val) {
        this.loading = true
        this.query_log.flag = '';
        this.query_log.page_limit = val;
        this.getOnlineList();
      },
      handleCurrentChange(val) {
        this.loading = true
        this.query_log.flag = '';
        this.query_log.page = val;
        this.getOnlineList();
      },
      handleSizeChange1(val) {
        this.loading = true;
        this.query.page_limit = val
        this.getCustomerFollowUpLogList()
      },
      handleCurrentChange1(val) {
        this.loading = true;
        this.query.page = val
        this.getCustomerFollowUpLogList()
      },
      handleSelectionChange(val) { //是否全选框框
        this.multipleSelection = val;
      },
      delAll() {
        this.$confirm('此操作将永久删除选中记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceCallDel({
            call_log_id: this.multipleSelection.map(i => {
              return i.call_log_id
            }).join(',')
          }).then((res) => {
            if (res.data.code == 0) {
              this.query_log.flag = ''
              this.getOnlineList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      },
      handleDeleteOffLine(row) {
        this.$confirm('此操作将永久删除该记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceLogDel({
            service_log_id: row.service_log_id
          }).then((res) => {
            if (res.data.code == 0) {
              this.query_log.flag = '';
              this.getOnlineList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      },
      handleDelete(index, row) { //删除
        this.$confirm('此操作将永久删除该记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceCallDel({
            call_log_id: row.call_log_id
          }).then((res) => {
            if (res.data.code == 0) {
              this.query_log.flag = '';
              this.getOnlineList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      },
      getOnlineList() {
        if (this.query_log.flag != 'export') this.loading_log = true
        userInfoAPI.serviceCallLog(this.query_log).then(res => {
          if (this.query_log.flag == 'export') {
            this.query_log.flag = ''
            let blob = new Blob([res.data], {
              type: 'application/zip'
            })
            let objectUrl = URL.createObjectURL(blob)
            let link = document.createElement('a')
            link.href = objectUrl
            link.setAttribute('download', '通话记录')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(objectUrl)
          } else {
            this.list_log = res.data.data.list || []
            this.query_log.total = res.data.data.page.count || 0
            if (this.query_log.page == 1) this.getLogList()
          }
          this.loading_log = false
        }).catch(() => {
          this.loading_log = false
        })
      },
      check() {
        if ((this.type == 3 || this.type == 2) && !this.service_audit_remark.trim()) {
          this.$message({
            type: 'error',
            message: '请输入不合格原因'
          })
          return
        }
        userInfoAPI.serviceStateV2({
          customer_id: this.query.customer_id,
          status: this.type, // 0=未审核 1=合格 2=不合格 3=终审不合格
          service_audit_remark: this.type != 1 ? this.service_audit_remark : '',
          service_log_add_date: this.recodeQuery.add_date
        }).then((res) => {
          if (res.data.code == 0) {
            this.service_audit_remark = ''
            this.dialogVisible1 = false
            this.getLogList()
            this.$message({
              type: 'success',
              message: res.data.msg
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      },

      // 线下开始
      getLogList() {
        this.recodeLoading = true
        userInfoAPI.serviceLogList(this.recodeQuery).then(res => {
          if (res && res.data.code == 0) {
            this.recordList = res.data.data.list || []
            if (this.recordList.length) {
              this.recordList.forEach(item1 => {
                item1.comment_files = []
                if (item1.service_comment_file_path && item1.service_comment_file_path
                  .length) {
                  let lastInx, suffix;
                  item1.service_comment_file_path.forEach(item => {
                    lastInx = item.lastIndexOf('.') + 1;
                    suffix = item.slice(lastInx, item.length);
                    if (suffix == 'jpg' || suffix == 'jpeg' || suffix ==
                      'png' || suffix == 'gif' || suffix == 'jfif' ||
                      suffix == 'bmp' || suffix == 'webp') {
                      item = {
                        url: item,
                        type: 'image'
                      }
                    } else {
                      item = {
                        url: item,
                        type: 'video'
                      }
                    }
                    item1.comment_files.push(item)
                  })
                }
              })
            }

            this.current_month_service_total_offline = res.data.data.page.count || 0
          }
          this.recodeLoading = false
        })
      },

      change(e) {
        if (e) {
          this.query.start_date = e[0]
          this.query.end_date = e[1]
        } else {
          this.query.start_date = ''
          this.query.end_date = ''
        }
      },
      handleClick(tab, event) {
        if (tab.index == 0) {
          this.getDetail()
        }
        if (tab.index == 2) {
          this.getCustomerFollowUpLogList()
        }
      },
      getDetail() {
        userInfoAPI.serviceCustomerDetail({
          customer_id: this.id
        }).then((res) => {
          this.pageData = res.data.data
        })
      },
      getCustomerFollowUpLogList() {
        userInfoAPI.customerFollowUpLogList(this.query).then((res) => {
          if (res.data.code == 0) {
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
          this.loading = false
        })
      },

      replay(item) {
        this.reply_content = ''
        this.serviceCommentItem = item
        this.getCommentReplyList()
      },
      getCommentReplyList() { // 评价回复列表
        userInfoAPI.serviceCommentList({
          service_log_id: this.serviceCommentItem.service_log_id,
          service_comment_id: this.serviceCommentItem.service_comment_id,
          page_limit: 999,
          page: 1
        }).then((res) => {
          this.commentList = res.data.data.list || []
          this.dialogVisible = true
        })
      },
      handelConfirm() {
        if (!this.reply_content.trim()) {
          this.$message({
            type: 'error',
            message: '请输入评价内容'
          });
          return
        }
        userInfoAPI.serviceCommentAdd({
          service_log_id: this.serviceCommentItem.service_log_id,
          service_comment_id: this.serviceCommentItem.service_comment_id,
          reply_content: this.reply_content,
        }).then((res) => {
          if (res.data.code == 0) {
            this.getCommentReplyList()
            this.reply_content = ''
            this.$message({
              type: 'success',
              message: res.data.msg
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      },
      del(item) {
        this.$confirm('此操作将永久删除该评论, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceCommentDel({
            reply_id: item.reply_id
          }).then((res) => {
            if (res.data.code == 0) {
              this.getCommentReplyList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
            }
          })
        })
      },
    },

    beforeDestroy() {},
    destroyed() {}
  }
</script>
<style lang='scss' scoped>
  ::v-deep{
    .my-date.el-input--suffix .el-input__inner{
      padding-right: 0;
    }
  }
  /deep/ .el-tabs__content {
    overflow: visible;
  }

  .record-box {
    min-height: 682px;
    margin-bottom: 40px;
    width: 80%;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.06);
    border: 1px solid #eeeeee;

    .off-box {
      border-bottom: 1px solid #eeeeee;
      margin-bottom: 20px;
    }
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .item {
    margin-bottom: 10px;

    .flexbox {
      justify-content: space-between;
      display: flex;
      margin-bottom: 5px;
      text-align: justify;

      i {
        cursor: pointer;

        &:hover {
          color: red;
        }
      }
    }
  }

  /*去掉tabs底部的下划线*/
  /deep/.el-tabs__nav-wrap::after {
    position: static !important;
  }

  .state-0 {
    color: #999999;
  }

  .state-1 {
    color: #00be00;
  }

  .state-2 {
    color: #e4be44;
  }

  .state-3 {
    color: red;
  }

  .details {
    margin: 10px 30px 0 30px;
  }

  .file-list {
    img {
      width: 60px;
      height: 60px;
      border-radius: 6px;
      cursor: pointer;
      margin-right: 10px;
    }
  }

  .el-divider {
    margin-top: 40px;
  }

  .el-divider__text {
    font-weight: bold;
    font-size: 18px;
  }

  .cc .el-form-item {
    margin-right: 10px;
    width: calc(50% - 10px);
  }

  ._empty-text {
    text-align: center;
    color: #909399;
    line-height: 100px;
    font-size: 13px;
  }

  .videomask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    top: 0;
    left: 0;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover i {
      transform: scale(1.1);
    }

    i {
      transition: all 0.2s;
      color: white;
      font-size: 33px;
    }
  }
</style>
